// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IPackageVersion {
	id: string | undefined;

	versionReportId: string | undefined;

	name: string | undefined;

	currentVersion: string | undefined;

	architecture: string | undefined;

	source: string | undefined;

	upgradableTo: string | undefined;

	$type?: string | undefined;
}
export class PackageVersion {
	constructor(data?: IPackageVersion) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	id: string | undefined;

	versionReportId: string | undefined;

	name: string | undefined;

	currentVersion: string | undefined;

	architecture: string | undefined;

	source: string | undefined;

	upgradableTo: string | undefined;

	static $type: string = "CoreApi.Models.Hardware.PackageVersion, ";
	$type?: string | undefined = PackageVersion.$type;
}

